import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e7c3914"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "ion-padding activeTrackingTitle" }
const _hoisted_3 = { class: "activeTrackingCardHeaderSubTitle" }
const _hoisted_4 = { style: {"min-width":"60%","float":"left"} }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"5px","padding-right":"5px"} }, "|", -1))
const _hoisted_6 = { style: {"min-width":"40%","float":"left"} }
const _hoisted_7 = { style: {"padding-left":"15px"} }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WeatherIcon = _resolveComponent("WeatherIcon")!
  const _component_disabled_map = _resolveComponent("disabled-map")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_card_subtitle = _resolveComponent("ion-card-subtitle")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!

  return ($setup.hasLastTracking)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString($setup.trackingName), 1),
        _createVNode(_component_ion_card, { class: "activeTrackingCard" }, {
          default: _withCtx(() => [
            _createVNode(_component_WeatherIcon, {
              "load-current-weather": false,
              weather: $setup.lastTracking.weatherItem
            }, null, 8, ["weather"]),
            _createVNode(_component_disabled_map, {
              disableMarkerUpdateEvent: true,
              zoom: $setup.mapsZoom,
              "street-view-control": false,
              "zoom-control": true,
              "init-cords": {lat: $setup.lastTrackingCoordinate?.latitude, lng: $setup.lastTrackingCoordinate?.longitude},
              "show-path": true,
              "path-coordinates": $setup.lastTracking.getAllCoordinatesForMap(),
              height: "14em"
            }, null, 8, ["zoom", "init-cords", "path-coordinates"]),
            _createVNode(_component_ion_card_header, { class: "activeTrackingCardHeader" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "4.5" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_title, { class: "last-tracking-title" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.trackingName), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_ion_icon, {
                                  icon: $setup.icons.location
                                }, null, 8, ["icon"]),
                                _createTextVNode(" " + _toDisplayString($setup.distanceFormatted) + " km ", 1),
                                _hoisted_5
                              ]),
                              _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_ion_icon, {
                                  style: {"float":"left"},
                                  icon: $setup.icons.timeOutline
                                }, null, 8, ["icon"]),
                                _createElementVNode("div", _hoisted_7, _toDisplayString($setup.duration), 1)
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_card_content, { class: "activeTrackingCardHeader" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_grid, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_card_subtitle, null, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString($setup.lastTrackTypeName) + " ", 1),
                                _createVNode(_component_ion_icon, { icon: $setup.lastTrackIcon }, null, 8, ["icon"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_card_subtitle, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, {
                                  icon: $setup.icons.location
                                }, null, 8, ["icon"]),
                                ($setup.startAddress && $setup.startAddress !== null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString($setup.startAddress.city), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString($setup.getStartAddress()), 1)),
                                _hoisted_10,
                                ($setup.endAddress && $setup.endAddress !== null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.endAddress.city), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString($setup.getEndAddress()), 1))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}